/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} FollowerInputs */

const en_follower = /** @type {(inputs: FollowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Followers`)
};

const de_follower = /** @type {(inputs: FollowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follower`)
};

/**
* | output |
* | --- |
* | "Followers" |
*
* @param {FollowerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const follower = /** @type {((inputs?: FollowerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<FollowerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_follower(inputs)
	return de_follower(inputs)
});